export class BillingGLAccountLabelSelectorResultDto {
    subledgerCode: string;
}
